import { makeStyles } from "@material-ui/core/styles";
import { COLORS, DRIVER_STATUS_COLORS } from "config/theme/baseTheme";

export const useStyles = makeStyles((theme) => ({
  container: {
    position: "fixed",
    zIndex: 1301,
    pointerEvents: "none",
    right: 690,
    bottom: 10,
    top: "auto",
    opacity: 1,
    left: "auto",
  },
  panel: {
    backgroundColor: COLORS.WHITE,
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    display: "flex",
    flexDirection: "column",
    borderRadius: "8px",
    pointerEvents: "auto",
  },
  panelWithTransition: {
    transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
  },
  panelClosed: {
    transform: "translateX(-120%)",
    opacity: 0,
  },
  toggleButton: {
    position: "absolute",
    right: "-40px",
    top: "50%",
    transform: "translateY(-50%)",
    backgroundColor: COLORS.SELECTED_BLUE,
    color: COLORS.WHITE,
    borderRadius: "0 8px 8px 0",
    padding: theme.spacing(1.5, 1),
    cursor: "pointer",
    boxShadow: "2px 2px 8px rgba(0,0,0,0.2)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "40px",
    pointerEvents: "auto",
    "&:hover": {
      backgroundColor: DRIVER_STATUS_COLORS.OUT_FOR_DELIVERY,
    },
  },
  badge: {
    "& .MuiBadge-badge": {
      backgroundColor: COLORS.ORANGE,
      color: COLORS.WHITE,
      fontWeight: 600,
    },
  },
  toggleLabel: {
    fontSize: "11px",
    marginTop: "4px",
    writingMode: "vertical-rl",
    textOrientation: "mixed",
  },
}));

export const getPanelStyle = (
  width: string | number,
  maxHeight: string
) => ({
  width,
  maxHeight,
});
